import {slideFromTo} from "../helpers";

class TabsMenu {

  constructor(el) {
    this.el = el
    this.navItems = el.querySelectorAll('.tabs-menu__nav-item')
    this.tabsContainer = el.querySelector('.tabs-menu__tabs')
    this.tabs = el.querySelectorAll('.tabs-menu-item')

    const self = this
    if ( ! this.el.classList.contains('alternative') ) {
      Array.from(this.navItems).forEach((navItem, index) => {
        if (index === 0) {
          navItem.classList.add('is-active')
          const tab = self.getTab(navItem.getAttribute('href'))
          console.log(tab)
          if (tab) {
            tab.classList.add('is-active')
          }
        }

        navItem.addEventListener('click', (e) => {
          self.onNavItemClick(e)
        })
      })
    }
  }

  onNavItemClick(e) {
    e.preventDefault()
    const navItem = e.currentTarget;
    const tab = this.getTab(navItem.getAttribute('href'))

    if (!navItem.classList.contains('is-active')) {
      const activeNavItem = this.getActiveNavItem()
      const activeTab = this.getActiveTab()

      activeNavItem.classList.remove('is-active')
      navItem.classList.add('is-active')

      slideFromTo(this.tabsContainer, activeTab.offsetHeight, tab.offsetHeight)
      activeTab.classList.remove('is-active')
      tab.classList.add('is-active')
    }
  }

  getActiveNavItem() {
    return Array.from(this.navItems).find(item => item.classList.contains('is-active'))
  }

  getActiveTab() {
    return Array.from(this.tabs).find(item => item.classList.contains('is-active'))
  }

  getTab(id) {
    id = id.replace('#', '')
    return Array.from(this.tabs).find(item => {
      return item.id === id
    })
  }
}

(() => {
  Array.from(document.querySelectorAll('.tabs-menu')).forEach(item => new TabsMenu(item))
})()